export default function Paper() {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0
      },
    }
  };
}
